import { useSearchParams } from "react-router-dom";

// Returns an object of specified query parameters from the URL
export const useQueryParams = (keys) => {
  const [searchParams] = useSearchParams();
  const queryParams = keys.reduce((acc, key) => {
    acc[key] = searchParams.get(key);
    return acc;
  }, {});

  return queryParams;
};
